<!--
UEditor封装，必填参数v-model，选填参数config和thumbnail-size

此Vue组件引用的UEditor为官方1.4.3版本，对其源码进行过修改，故引用时请引用/statc/plugins/ueditor/ueditor.all.js
其源码主要修改内容为：
增加缩略图参数、单图上传、上传完成回调方法，行号：23770、24518、24530、24544。by 张圣伟 2019年6月24日 10:52:40
官方缺陷，上传图片后依然是loading，未替换图片路径，手动调用contentChange事件可解决，行号：24549.by 张圣伟 2019年6月24日 10:52:40
-->
<template>
  <div>
    <div :id="id"></div>
  </div>
</template>
<script>
export default {
  /* eslint-disable */
  name: 'UE',
  data() {
    return {
      editor: null,
      id: 'ueditor' + Math.random(),
      readied: false, // 实例是否已经ready
      initialValue: '' // 初始值
    };
  },
  props: {
    // 已实现v-model语法糖，调用时数据绑定请直接用v-model
    value: {
      type: String,
      default: ''
    },
    config: {
      type: Object,
      default: {}
    },
    // 缩略图参数，默认600宽，不限高
    thumbnailSize: {
      type: Object,
      default() {
        // return { width: 600 }; // 改为服务端处理
        return {};
      }
    }
  },
  watch: {
    value: {
      handler(value) {
        // 此处setContent调用的为组件内的setContent，并非是UEditor的setContent
        this.editor ? this.setContent(value) : this.initEditor(value);
      },
      immediate: true
    }
  },
  methods: {
    initEditor(value) {
      this.$nextTick(() => {
        this.editor = window.UE.getEditor(this.id, this.config);
        this.initialValue = value;
        this.editor.addListener('ready', () => {
          this.readied = true;
          this.$emit('ready', this.editor);
          this.editor.setContent(this.initialValue);
          this.editor.addListener('contentChange', () => {
            this.$emit('input', this.editor.getContent());
            this.$emit('change', {
              content: this.editor.getContent(),
              plainTxt: this.editor.getPlainTxt(),
              wordCount: this.editor.getContentLength(true)
            });
          });
        });
      });
    },
    // 重写设置内容，为了避免重复设置
    setContent(value) {
      if (this.readied) {
        value === this.editor.getContent() || this.editor.setContent(value);
      } else {
        this.initialValue = value;
      }
    }
  },
  mounted() {
    // 缩略图参数
    this.config.thumbnailSize = this.thumbnailSize;
    // 单图上传事件
    this.config.simpleImageUploading = () => {
      this.$emit('simple-image-uploading', this.editor);
    };
    // 单图上传完成事件
    this.config.simpleImageUploaded = () => {
      this.$emit('simple-image-uploaded', this.editor);
    };
    // 以上参数于UEditor源码内部处理
  },
  destroyed() {
    this.editor.destroy();
  }
};
</script>


// WEBPACK FOOTER //
// src/common/component/ueditor.vue